import { SANITY_PROJECT_ID, SANITY_DATASET } from "../../../src/globals";

export function assetRefToSanityUrl(assetRef: string): string {
  return `/sanity-images/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${assetRef.slice(6).replace("-png", ".png").replace("-jpg", ".jpg")}`;
}

/**
 * URL for a Sanity *file* asset ref (`file-<hash>-<ext>`), proxied through our
 * own origin. The app sets `Cross-Origin-Embedder-Policy: require-corp`, which
 * blocks media loaded straight from cdn.sanity.io, so files go through the
 * `/sanity-files/*` redirect the same way images use `/sanity-images/*`.
 */
export function assetRefToSanityFileUrl(assetRef: string): string {
  const path = assetRef.replace(/^file-/, "").replace(/-([a-z0-9]+)$/i, ".$1");
  return `/sanity-files/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${path}`;
}
